import axios from 'axios';

import { UcrService, serviceOptions } from './__generated__';
import { clearEmptyParamsInterceptor } from './interceptors/clearEmptyParams';
import { has401Interceptor } from './interceptors/has401';
import { xRequestIdInterceptor } from './interceptors/xRequestId';

const baseURL = import.meta.env.__UCR_API_URL__;

const instance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

xRequestIdInterceptor(instance.interceptors.request);
has401Interceptor(instance.interceptors.response);
clearEmptyParamsInterceptor(instance.interceptors.request);

serviceOptions.axios = instance;

export const apiClient = UcrService;
